module.exports = __webpack_public_path__ + "static/img/qualifications_icon_10.068bf2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/qualifications_icon_10.png
// module id = w7Xo
// module chunks = 3